module.exports = __webpack_public_path__ + "img/dental10_7-8-2021.5664add6.jpg";